import { IconProps } from 'interfaces';
import COLOR from 'constants/color';

const Image = ({
  fill = COLOR.GRAY['900'],
  className = 'w-4 h-4',
  styles
}: IconProps) => {
  return (
    <svg
      className={styles || className}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      preserveAspectRatio='xMidYMid meet'
    >
      <rect
        x='3'
        y='3'
        width='18'
        height='18'
        rx='2'
        ry='2'
        stroke={fill}
        strokeWidth='2'
        fill='none'
      />
      <circle
        cx='8.5'
        cy='8.5'
        r='1.5'
        stroke={fill}
        strokeWidth='2'
        fill='none'
      />
      <path
        d='M21 15l-5-5L5 21'
        stroke={fill}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill='none'
      />
    </svg>
  );
};

export default Image;
